import { environment as environmentFromFile } from "./environment";
export function readFromEnv(key) {
    var envValue = environmentFromFile[key];
    if (envValue === undefined || envValue === null) {
        throw new Error("\n        Missing environment variable value for key ".concat(key, ".\n        Running locally: Do you have a .env.local file in your app folder that contains ").concat(key, "?\n        Running in CI: Is ").concat(key, " exposed in the CI pipeline file?\n        "));
    }
    return envValue;
}
export { Env } from "./environment.types";
